<script lang="ts" setup>
const activeIndex = ref(0)

provide('activeIndex', activeIndex)
</script>

<template>
  <div class="tabs">
    <ul class="tabs-header cul">
      <slot name="headers" />
    </ul>
    <div class="tabs-content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tabs-header {
  display: flex;
  gap: 24px;

  margin-bottom: 24px;

  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;

  width: calc(100% + calc((100vw - var(--container-max-width)) / 2 + 1px));
}
</style>
